var _rect, _g, _g2, _rect2, _path, _rect3, _circle, _circle2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStatusRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 29,
    width: 114.4,
    height: 92.4,
    rx: 4.4,
    fill: "#E7E9EC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#large_success_icon_clip_0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#large_success_icon_0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.9996,
    cy: 65.9996,
    r: 48.4,
    fill: "#053668"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#large_success_icon_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.998,
    y: 22,
    width: 114.4,
    height: 92.4,
    rx: 4.4,
    fill: "#073459"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7988,
    y: 19.7998,
    width: 114.4,
    height: 92.4,
    rx: 4.4,
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7988 30.7998H135.199V107.8C135.199 110.23 133.229 112.2 130.799 112.2H25.1988C22.7688 112.2 20.7988 110.23 20.7988 107.8V30.7998Z",
    fill: "url(#large_success_icon_linear_0)",
    fillOpacity: 0.2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 135.199,
    y: 28.5996,
    width: 2.2,
    height: 114.4,
    transform: "rotate(90 135.199 28.5996)",
    fill: "#053668"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7988 19.7998H135.199V30.7998H20.7988V19.7998Z",
    fill: "url(#large_success_icon_linear_1)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3992,
    cy: 24.2,
    r: 2.2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9988,
    cy: 24.2,
    r: 2.2,
    fill: "#80E1D6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#large_success_icon_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3192 70.3996C90.3192 77.2037 84.8033 82.7196 77.9992 82.7196C71.1952 82.7196 65.6792 77.2037 65.6792 70.3996C65.6792 63.5955 71.1952 58.0796 77.9992 58.0796C84.8033 58.0796 90.3192 63.5955 90.3192 70.3996ZM84.1592 70.3996C84.1592 73.8017 81.4014 76.5596 77.9992 76.5596C74.597 76.5596 71.8392 73.8017 71.8392 70.3996C71.8392 66.9975 74.597 64.2396 77.9992 64.2396C81.4014 64.2396 84.1592 66.9975 84.1592 70.3996Z",
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3192 70.3996C90.3192 77.2037 84.8033 82.7196 77.9992 82.7196C71.1952 82.7196 65.6792 77.2037 65.6792 70.3996C65.6792 63.5955 71.1952 58.0796 77.9992 58.0796C84.8033 58.0796 90.3192 63.5955 90.3192 70.3996ZM84.1592 70.3996C84.1592 73.8017 81.4014 76.5596 77.9992 76.5596C74.597 76.5596 71.8392 73.8017 71.8392 70.3996C71.8392 66.9975 74.597 64.2396 77.9992 64.2396C81.4014 64.2396 84.1592 66.9975 84.1592 70.3996Z",
    fill: "url(#large_success_icon_linear_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.233 42.5258C73.3149 40.8866 74.6677 39.5996 76.3092 39.5996H79.6892C81.3307 39.5996 82.6835 40.8866 82.7655 42.5258L82.8668 44.5529C82.9169 45.5561 83.6433 46.3878 84.611 46.6567C86.5516 47.196 88.3958 47.9667 90.112 48.9374C90.9862 49.4318 92.0877 49.3571 92.8324 48.6833L94.3399 47.3193C95.5569 46.2182 97.4237 46.2648 98.5843 47.4254L100.974 49.8156C102.135 50.9762 102.182 52.8429 101.08 54.0599L99.7163 55.5678C99.0425 56.3124 98.9679 57.4139 99.4622 58.288C100.433 60.0039 101.203 61.8477 101.742 63.7878C102.011 64.7555 102.843 65.4817 103.846 65.5319L105.873 65.6333C107.512 65.7152 108.799 67.0682 108.799 68.7095V72.0897C108.799 73.731 107.512 75.084 105.873 75.166L103.846 75.2673C102.843 75.3175 102.011 76.0438 101.742 77.0114C101.203 78.9519 100.432 80.7961 99.4616 82.5122C98.9672 83.3863 99.0418 84.4879 99.7156 85.2325L101.079 86.7395C102.18 87.9565 102.134 89.8232 100.973 90.9838L98.5828 93.3739C97.4222 94.5345 95.5554 94.5811 94.3384 93.4801L92.8313 92.1165C92.0866 91.4427 90.9851 91.3681 90.1109 91.8624C88.3951 92.8328 86.5512 93.6033 84.611 94.1424C83.6433 94.4113 82.9169 95.243 82.8668 96.2462L82.7655 98.2734C82.6835 99.9126 81.3307 101.2 79.6892 101.2H76.3092C74.6677 101.2 73.3149 99.9126 73.233 98.2734L73.1317 96.2462C73.0815 95.243 72.3552 94.4113 71.3874 94.1424C69.4472 93.6033 67.6033 92.8327 65.8875 91.8624C65.0134 91.368 63.9118 91.4427 63.1672 92.1165L61.6608 93.4794C60.4437 94.5805 58.577 94.5339 57.4168 93.3734L55.0263 90.9832C53.8657 89.8226 53.819 87.9559 54.9203 86.7389L56.2829 85.2327C56.9566 84.488 57.0312 83.3865 56.5369 82.5124C55.5662 80.7962 54.7955 78.952 54.2563 77.0114C53.9874 76.0438 53.1557 75.3175 52.1526 75.2673L50.1254 75.166C48.4862 75.084 47.1992 73.731 47.1992 72.0897V68.7095C47.1992 67.0682 48.4862 65.7152 50.1254 65.6333L52.1526 65.5319C53.1557 65.4817 53.9874 64.7555 54.2563 63.7878C54.7955 61.8477 55.5661 60.0038 56.5365 58.288C57.0309 57.4138 56.9562 56.3123 56.2824 55.5677L54.9188 54.0605C53.8179 52.8435 53.8645 50.9768 55.0252 49.8162L57.4153 47.4259C58.5759 46.2654 60.4426 46.2188 61.6597 47.3199L63.1664 48.6832C63.9111 49.357 65.0126 49.4316 65.8868 48.9373C67.6029 47.9667 69.447 47.1959 71.3875 46.6567C72.3552 46.3878 73.0815 45.5561 73.1317 44.5529L73.233 42.5258ZM96.4792 70.3996C96.4792 80.6058 88.2054 88.8796 77.9992 88.8796C67.793 88.8796 59.5192 80.6058 59.5192 70.3996C59.5192 60.1934 67.793 51.9196 77.9992 51.9196C88.2054 51.9196 96.4792 60.1934 96.4792 70.3996Z",
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.233 42.5258C73.3149 40.8866 74.6677 39.5996 76.3092 39.5996H79.6892C81.3307 39.5996 82.6835 40.8866 82.7655 42.5258L82.8668 44.5529C82.9169 45.5561 83.6433 46.3878 84.611 46.6567C86.5516 47.196 88.3958 47.9667 90.112 48.9374C90.9862 49.4318 92.0877 49.3571 92.8324 48.6833L94.3399 47.3193C95.5569 46.2182 97.4237 46.2648 98.5843 47.4254L100.974 49.8156C102.135 50.9762 102.182 52.8429 101.08 54.0599L99.7163 55.5678C99.0425 56.3124 98.9679 57.4139 99.4622 58.288C100.433 60.0039 101.203 61.8477 101.742 63.7878C102.011 64.7555 102.843 65.4817 103.846 65.5319L105.873 65.6333C107.512 65.7152 108.799 67.0682 108.799 68.7095V72.0897C108.799 73.731 107.512 75.084 105.873 75.166L103.846 75.2673C102.843 75.3175 102.011 76.0438 101.742 77.0114C101.203 78.9519 100.432 80.7961 99.4616 82.5122C98.9672 83.3863 99.0418 84.4879 99.7156 85.2325L101.079 86.7395C102.18 87.9565 102.134 89.8232 100.973 90.9838L98.5828 93.3739C97.4222 94.5345 95.5554 94.5811 94.3384 93.4801L92.8313 92.1165C92.0866 91.4427 90.9851 91.3681 90.1109 91.8624C88.3951 92.8328 86.5512 93.6033 84.611 94.1424C83.6433 94.4113 82.9169 95.243 82.8668 96.2462L82.7655 98.2734C82.6835 99.9126 81.3307 101.2 79.6892 101.2H76.3092C74.6677 101.2 73.3149 99.9126 73.233 98.2734L73.1317 96.2462C73.0815 95.243 72.3552 94.4113 71.3874 94.1424C69.4472 93.6033 67.6033 92.8327 65.8875 91.8624C65.0134 91.368 63.9118 91.4427 63.1672 92.1165L61.6608 93.4794C60.4437 94.5805 58.577 94.5339 57.4168 93.3734L55.0263 90.9832C53.8657 89.8226 53.819 87.9559 54.9203 86.7389L56.2829 85.2327C56.9566 84.488 57.0312 83.3865 56.5369 82.5124C55.5662 80.7962 54.7955 78.952 54.2563 77.0114C53.9874 76.0438 53.1557 75.3175 52.1526 75.2673L50.1254 75.166C48.4862 75.084 47.1992 73.731 47.1992 72.0897V68.7095C47.1992 67.0682 48.4862 65.7152 50.1254 65.6333L52.1526 65.5319C53.1557 65.4817 53.9874 64.7555 54.2563 63.7878C54.7955 61.8477 55.5661 60.0038 56.5365 58.288C57.0309 57.4138 56.9562 56.3123 56.2824 55.5677L54.9188 54.0605C53.8179 52.8435 53.8645 50.9768 55.0252 49.8162L57.4153 47.4259C58.5759 46.2654 60.4426 46.2188 61.6597 47.3199L63.1664 48.6832C63.9111 49.357 65.0126 49.4316 65.8868 48.9373C67.6029 47.9667 69.447 47.1959 71.3875 46.6567C72.3552 46.3878 73.0815 45.5561 73.1317 44.5529L73.233 42.5258ZM96.4792 70.3996C96.4792 80.6058 88.2054 88.8796 77.9992 88.8796C67.793 88.8796 59.5192 80.6058 59.5192 70.3996C59.5192 60.1934 67.793 51.9196 77.9992 51.9196C88.2054 51.9196 96.4792 60.1934 96.4792 70.3996Z",
    fill: "url(#large_success_icon_linear_3)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "large_success_icon_0",
    x: -23.2004,
    y: -35.2004,
    width: 202.4,
    height: 202.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "large_success_icon_1",
    x: 16.398,
    y: 15.4,
    width: 127.6,
    height: 105.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "large_success_icon_2",
    x: 43.8992,
    y: 36.2996,
    width: 70.4,
    height: 70.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.1,
    dy: 1.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "large_success_icon_linear_0",
    x1: 20.7988,
    y1: 30.7998,
    x2: 137.922,
    y2: 40.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "large_success_icon_linear_1",
    x1: 77.9988,
    y1: 19.7998,
    x2: 77.9988,
    y2: 30.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "large_success_icon_linear_2",
    x1: 47.203,
    y1: 39.5996,
    x2: 93.0709,
    y2: 111.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "large_success_icon_linear_3",
    x1: 47.203,
    y1: 39.5996,
    x2: 93.0709,
    y2: 111.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "large_success_icon_clip_0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white",
    transform: "translate(12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatusRules);
export default __webpack_public_path__ + "static/media/empty-status-rules.755eedbe.svg";
export { ForwardRef as ReactComponent };